import React, { FC } from 'react';

import { IconProps } from 'types/components';

const Icon: FC<IconProps> = ({
  xmlns = 'http://www.w3.org/2000/svg',
  viewBox = '0 0 24 24',
  width = '1em',
  height = '1em',
  fill = 'currentColor',
  ...props
}) => (
  <svg
    xmlns={xmlns}
    viewBox={viewBox}
    width={width}
    height={height}
    fill={fill}
    {...props}
  />
);

export default Icon;
